import React, { useEffect, useState } from "react";
import { Button, Col, Input, Row } from "antd";
import { toast } from "react-toastify";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import AcademicYearSelect from "../../../core/common/AcademicYearSelect";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { _get, _post } from "../../Utils/Helper";
import { acadamicTerms } from "../../../core/common/selectoption/selectoption";
import { SingleValue } from "react-select";

// Payment Interface
interface Payment {
    id?:number,
  amount: number;
  term: string;
  academic_year: string;
  admission_no: string;
  school_id: string;
  item_code: string;
  description: string;
  status: string;
  ref_no:string;
  is_optional: string;
  student_type: string;
  discount: number;
  fines: number;
  checked: boolean;
  amount_paid: number;
}

// Props
interface StudentPayModalsProps {
  admission_no?: string;
  academic_year: string;
  term: string;
  student_name: string
  class_name:string
}

const EditBillModals: React.FC<StudentPayModalsProps> = ({
  admission_no,
  student_name,
  academic_year,
  class_name,
  term }) => {
  const [payments, setPayments] = useState<Payment[]>([]);
  const [selectedRows, setSelectedRows] = useState<Payment[]>([]);
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state: RootState) => state.auth);

  const [form, setForm] = useState({
    payment_mode: "Cash Deposite",
    query_type: "update-paid",
    admission_no: admission_no || "",
    created_by: user?.name || "",
    payment_date: moment().format("YYYY-MM-DD"),
    status: "Paid",
    academic_year: academic_year || "",
    term: term || "",
  });

  // Fetch student payment data
  useEffect(() => {
    if (admission_no) {
      setLoading(true);
      _post(
        "payments",
        {
          query_type: "select",
          admission_no,
          term: form.term,
          academic_year: form.academic_year
        },
        (resp) => {
          if (resp.success) {
            const paymentData = resp.data.map((x: Payment) => ({
              ...x,
              checked: x.is_optional === "No",
            }));
            setPayments(paymentData);
            setSelectedRows(paymentData.filter((p: any) => p.checked));
          }
          setLoading(false);
        },
        (err) => {
          console.error(err);
          setLoading(false);
        }
      );
    }
  }, [admission_no, form.term, form.academic_year]);

  // Handle Selection
  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      setSelectedRows([...payments.filter((x)=>x.status!=='Paid')]);
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowSelection = (e: React.ChangeEvent<HTMLInputElement>, payment: Payment) => {
    setSelectedRows((prev) =>
      prev.some((p) => p.item_code === payment.item_code)
        ? prev.filter((p) => p.item_code !== payment.item_code)
        : [...prev, payment]
    );
  };

  const totalAmount = selectedRows.reduce(
    (sum, payment) => sum + Math.floor(payment.amount),
    0
  );
  const totalDiscount = selectedRows.reduce(
    (sum, payment) => sum + Math.floor(payment.discount),
    0
  );
  const totalFines = selectedRows.reduce(
    (sum, payment) => sum + Math.floor(payment.fines),
    0
  );

  // Handle Submit
  const handleSubmit = () => {
    const paymentData = selectedRows.map((payment) => ({
      ref_no:payment.ref_no,
      id:payment.id,
      query_type:"delete"
    }));

    setLoading(true);
    _post(
      "payments",
      paymentData,
      (resp) => {
        if (resp.success) {
          toast.success("Payment processed successfully");
          setPayments([]);
          setSelectedRows([]);
        }
        setLoading(false);
      },
      (err) => {
        toast.error("Payment processing failed");
        console.error(err);
        setLoading(false);
      }
    );
  };

  const isAllSelected = selectedRows.length > 0 && (selectedRows.length === payments.length)

  return (
    <div className="modal fade" id="student_bill_update_modal">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{"Process Payment".toUpperCase()}

              <div className="ml-8 mb-3">
                {student_name} ({admission_no})
              </div>
            </h5>
            <button
              type="button"
              className="btn-close bg-danger text-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <Row>
              <Col> <AcademicYearSelect
                onChange={(year) => {
                  setForm((p) => ({ ...p, academic_year: year }))
                }}
                selectedYear={form.academic_year}
              />
              </Col>
              <Col>
                <CommonSelect
                  placeholder="Select Term"
                  className="select"
                  options={acadamicTerms}
                  defaultValue={{
                    label: form.term,
                    value: form.term,
                  }}
                  handleChange={(newValue: SingleValue<Option>) =>
                    setForm((prev) => ({
                      ...prev,
                      term: newValue ? newValue.value : "",
                    }))
                  }
                />
              </Col>
            </Row>
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>
                      <Input
                        type="checkbox"
                        checked={isAllSelected}
                        onChange={handleSelectAll}
                      />
                    </th>
                    <th>Description</th>
                    <th>Amount</th>
                    <th>Paid</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {payments.filter((x: Payment) => x.amount > 0).map((payment: Payment, index:number) => (
                    <tr key={index}>

                      <td>
                        {index+1}
                        <Input
                          type="checkbox"
                          checked={selectedRows.some((p) => p.item_code === payment.item_code)}
                          onChange={(e) =>{
                            if(payment.status!=='Paid'){
                             handleRowSelection(e, payment)}}}
                        />
                      </td>
                      <td>{payment.description}</td>
                      <td>{payment.amount}</td>
                      <td>{payment.amount_paid}</td>
                      <td>{payment.status === "Paid" ? (
                        <span className="badge badge-soft-success d-inline-flex align-items-center">
                          <i className="ti ti-circle-filled fs-5 me-1"></i>
                          {payment.status}
                        </span>
                      ) : (
                        <span className="badge badge-soft-danger d-inline-flex align-items-center">
                          <i className="ti ti-circle-filled fs-5 me-1"></i>
                          {payment.status}
                        </span>
                      )}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between mt-3 row">
              <div className="col-md-4">
               

              </div>
              <div className="col-md-4">
                <br/>
                <br/>
                <Button type="primary" onClick={() => handleSubmit()} loading={loading}>
                  Delete {selectedRows.length} items
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBillModals;
